import React from 'react'
import { useRouter } from 'next/router'
import { Task } from '@core/entities/task/Task'
import { Flex, Text } from '@fundamentals'
import { Card, Divider } from '@common/material'
import { CardContent } from '@mui/material'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { localizedStrings } from '@core/strings'
import { PageUrls } from '@core/page-urls'
import { Section } from '@common/Section'
import { useNavigationContext } from '@common/hooks'
import { UserProfileHoverWrapper } from '@elements/UserProfileHoverWrapper'

type TaskPeopleCardProps = {
  task: Task
}

export const TaskPeopleCard: React.FC<TaskPeopleCardProps> = ({ task }) => {
  const { organisationId } = useNavigationContext()
  const router = useRouter()

  return (
    <Card>
      <CardContent>
        <Text
          showTooltip
          sx={{ fontSize: '16px' }}
          variant='h6'
          color='text.primary'
          gutterBottom
        >
          {localizedStrings.people}
        </Text>
        <Divider />

        {task?.createdBy && (
          <Section label={localizedStrings.creator} mt={2}>
            <Flex
              justifyContent='space-between'
              alignItems='center'
              onClick={() =>
                router.push(
                  PageUrls.organisationUserProfile({
                    organisationId,
                    userId: task.createdBy.id,
                  }),
                )
              }
              sx={{ cursor: 'pointer' }}
            >
              <UserProfileHoverWrapper
                userId={task?.createdBy?.id}
                organisationId={organisationId}
              >
                <Text>{task?.createdBy?.getFullName()}</Text>
              </UserProfileHoverWrapper>
              <ChevronRight />
            </Flex>
          </Section>
        )}

        {task?.assignee && (
          <Section label={localizedStrings.fixer} mt={2}>
            <Flex
              justifyContent='space-between'
              alignItems='center'
              onClick={() =>
                router.push(
                  PageUrls.organisationUserProfile({
                    organisationId,
                    userId: task.assignee.id,
                  }),
                )
              }
              sx={{ cursor: 'pointer' }}
            >
              <UserProfileHoverWrapper
                userId={task?.assignee?.id}
                organisationId={organisationId}
              >
                <Text>{task?.assignee?.getFullName()}</Text>
              </UserProfileHoverWrapper>
              <ChevronRight />
            </Flex>
          </Section>
        )}
      </CardContent>
    </Card>
  )
}
